'use client'

import './globals.css'
import React, { useEffect } from 'react'
import { Inter } from 'next/font/google'
import Header from './_components/Header'
import { Toaster } from 'react-hot-toast'
import AlphaDialog from './_components/AlphaDialog'
import { AuthRolesProvider } from './_contexts/AuthRolesContext'

const inter = Inter({ subsets: ['latin'] })

export default function RootLayout({ children }) {
    useEffect(() => {
        const handleScroll = () => {
            const scrollTop =
                window.scrollY || document.documentElement.scrollTop
            const event = new CustomEvent('profileScroll', {
                detail: { scrollTop },
            })
            document.dispatchEvent(event)
        }

        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    return React.createElement(
        'html',
        { lang: 'en' },
        React.createElement(
            'body',
            {
                className: `${inter.className} text-contrast-primary dark:bg-gray-900`,
            },
            React.createElement(
                AuthRolesProvider,
                null,
                React.createElement(
                    'div',
                    { className: 'min-h-screen flex flex-col' },
                    React.createElement(Header, null),
                    React.createElement(
                        'main',
                        { className: 'flex-1' },
                        children
                    )
                ),
                React.createElement(Toaster, { position: 'bottom-right' }),
                React.createElement(AlphaDialog, null)
            )
        )
    )
}
